<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">
      <form @submit.prevent="updateProfile">
        <div class="form-header">{{$t('edit.header')}}</div>
        {{message}}
        <div class="form-group">
          <input type="text" class="form-control" v-model="name" :placeholder="$t('edit.name')" :class="{'form-error': errorMessage['name']}" autocomplete="off" />
          <p v-for="msg in errorMessage['name']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="phone" :placeholder="$t('edit.phone')" :class="{'form-error': errorMessage['phone']}" autocomplete="off" disabled="disabled" />
          <p v-for="msg in errorMessage['phone']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="text" class="form-control" v-model="email" :placeholder="$t('edit.email')" :class="{'form-error': errorMessage['email']}" autocomplete="off" />
          <p v-for="msg in errorMessage['email']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" v-model="oldPassword" :placeholder="$t('edit.oldPassword')" :class="{'form-error': errorMessage['oldPassword']}" autocomplete="off" />
          <p v-for="msg in errorMessage['oldPassword']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" v-model="newPassword" :placeholder="$t('edit.newPassword')" :class="{'form-error': errorMessage['newPassword']}" autocomplete="off" />
          <p v-for="msg in errorMessage['newPassword']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" v-model="passwordRepeat" :placeholder="$t('edit.passwordRepeat')" :class="{'form-error': errorMessage['passwordRepeat']}" autocomplete="off" />
          <p v-for="msg in errorMessage['passwordRepeat']" class="text-error">{{msg}}</p>
        </div>
        
        <div class="row">
          <div class="col-xs-6">
            <div class="form-group text-right btn-submit">
              <base-button type="button" class="btn-block btn-default" @click="goBack()">{{$t('edit.cancel')}}</base-button>
            </div>
          </div>

          <div class="col-xs-6">
            <div class="form-group text-right btn-submit">
              <base-button type="submit" class="btn-block" :disabled="name.length == 0 || phone.length == 0 || email.length == 0">{{$t('edit.save')}}</base-button>
            </div>
          </div>

          <div class="clearfix"></div>
        </div>

        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
  import file from '@fortawesome/fontawesome-free-regular/faFile';
  import check from '@fortawesome/fontawesome-free-solid/faCheck';

  export default {
    components: {
      BaseHeader,
      BaseButton,
      FontAwesomeIcon,
    },
    name: 'EditPage',
    props: {
      sip_create: [Boolean, Number, String],
      sip_update: [Boolean, Number, String],
      sip_delete: [Boolean, Number, String],
    },
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        passwordRepeat: '',
        newPassword: '',
        oldPassword: '',
        errorMessage: [],
        user: {},
        message: '',
        sipList: [],
      };
    },
    computed: {
      fileIco() {
        return file;
      },
      fileCheck() {
        return check;
      }
    },
    methods: {
      updateProfile() {
        this.message = '';
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('name', this.name);
        formData.append('email', this.email);
        formData.append('phone', this.phone);
        formData.append('oldPassword', this.oldPassword);
        formData.append('newPassword', this.newPassword);
        formData.append('passwordRepeat', this.passwordRepeat);
        this.axios.post('/updateProfile?token=' + token, formData).then(response => {
          if (response.data.status) {
            //this.message = response.data.message;
            this.$router.push({name: 'EditPage', params: {update_profile: response.data.update}});
          } else {
            this.errorMessage = response.data.data;
          }
        })
      },
      logout() {
        const token = localStorage.getItem('token');
        this.axios.post('/logout?token=' + token).then((response) => {
          if (response.data.status) {
            localStorage.removeItem('token');
            localStorage.removeItem('url');
          }
          this.$router.push({name: 'LoginPage'});
        });
      },
      goBack() {
        if (window.history.length > 0) {
          window.history.back();
        } else {
          this.$router.push({name: 'EditPage'});
        }
      }
    },
    beforeMount () {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({name: 'LoginPage'});
      }
      this.axios.get('/sipList?token=' + token).then(response => {
        if (response.data.status && response.data.data.sip.length > 0 && response.data.data.user) {
          this.phone = response.data.data.user.phone;
          this.email = response.data.data.user.email;
          this.name = response.data.data.user.name;
          this.sipList = response.data.data.sip;
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('url');
          this.$router.push({name: 'LoginPage'});
        }
      })
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/EditProfile.vue